export default class Report {
  constructor(obj){
      obj = obj || {};
      this.reportId = obj.reportId;
      this.reportName = obj.reportName;
  }
}
